export const ENABLE_MAIN_ITEM_DETAILED_CUSTOMIZATION = false;
